import React from 'react';
export const AsanaSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.4756 20.9301C24.8722 20.9301 21.9512 23.8512 21.9512 27.4548C21.9512 31.0582 24.8722 33.9793 28.4756 33.9793C32.079 33.9793 35 31.0582 35 27.4548C35 23.8512 32.079 20.9301 28.4756 20.9301ZM11.5245 20.9306C7.92113 20.9306 5 23.8512 5 27.4548C5 31.0582 7.92113 33.9793 11.5245 33.9793C15.1279 33.9793 18.0492 31.0582 18.0492 27.4548C18.0492 23.8512 15.1279 20.9306 11.5245 20.9306ZM26.5243 12.7743C26.5243 16.3779 23.6033 19.2994 20.0001 19.2994C16.3965 19.2994 13.4756 16.3779 13.4756 12.7743C13.4756 9.17141 16.3965 6.25 20.0001 6.25C23.6033 6.25 26.5243 9.17141 26.5243 12.7743Z"
			fill="#F06A6A"
		/>
	</svg>
);
